import { useContext } from 'react'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faLock,
  faLockOpen,
  faArrowUpFromBracket,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Trans } from '@lingui/macro'
import Button from 'Root/App/Button'
import ItemVisibility from 'Root/App/Item/ItemVisibility'
import ShareOrCopy from 'Root/Component/ShareOrCopy'
import { Context } from 'Root/Contexts/Share'
import { isMatching } from 'lib/breakpoint-helper'
import { useIsClient } from 'lib/use-is-client'

library.add(faLock, faLockOpen, faArrowUpFromBracket)

export interface Props {
  /**
   * Use navigator share if available.
   */
  navigatorShare?: boolean
  id: string
}

const ShareOrCopyHeader: React.FC<Props> = ({ id }): JSX.Element => {
  const shareData = useContext(Context)

  const isClient = useIsClient()

  if (!isClient) return null

  const isMobile = isMatching('sm', true)

  const shareContent = isMobile ? (
    <span className="flex justify-center items-center w-10 h-10">
      <FontAwesomeIcon
        className="text-sm text-gray-500 bg-gray-200"
        icon={['fas', 'arrow-up-from-bracket']}
      />
    </span>
  ) : (
    <Trans>Condividi</Trans>
  )

  return (
    <ShareOrCopy
      id={id}
      openDialogButton={
        <Button
          icon={
            <ItemVisibility
              id={id}
              visibility={shareData.visibility}
              wrapperClassName="justify-center bg-gray-200 border-white border-r-2 rounded-l-lg w-10 h-10 box-content"
            />
          }
          iconPos="pre"
          className="sm:text-gray-500 bg-gray-200"
          size="S"
        >
          {shareContent}
        </Button>
      }
    />
  )
}

export default ShareOrCopyHeader
